import React, {Component} from 'react';
import {Avatar, Button, Card, Form, Input, Modal, Spin} from "antd";
import CreateSetting from "./settingChangeForm";

export default class PageSettingPopUp extends Component {
  // const {visible, toggleVisible} =  props;
  componentDidMount() {
    if (this.props.fetchPageSettingFilter)
      this.props.fetchPageSettingFilter();
  }

  getPageFilterData = (module) => {
    if (module)
      this.props.fetchPageWiseFields(module);
  }

  updateResource = (values, id) => {
    this.props.updatePageSetting(values, id);
  };

  // handleFormChange = (changedFields) => {
  //   this.setState(({fields}) => ({
  //     fields: {...fields, ...changedFields},
  //   }));
  // };

  render() {
    const {
      visible,
      toggleVisible,
    } = this.props;


    return (
      <div>

        <Modal
          title={'Page Setting'}
          toggle={toggleVisible} visible={visible}
          closable={false}
          onOk={toggleVisible}
          onCancel={toggleVisible}
          footer={null}
        >

          <CreateSetting data={this.props.pageSettingData}
                         filters={this.props.pageSettingFilters}
                         // modules={modules}
                         page={this.props.page}
                         title={'EDIT'}
                         resource={'PageSetting'}
                         fetch={this.props.fetchResourceByPage}
                         onChange={this.handleFormChange}
                         onSubmit={this.props.updatePageSetting}
                         getPageFilterData={this.props.fetchPageWiseFields}
                         pageData={this.props.pageWiseFields}
                         loading={this.props.loading}
          />
        </Modal>


      </div>
    );
  }
}

// const mapStateToProps = ({auth, pageSetting, commonData}) => {
//   return {
//     authUser: auth.authUser,
//     total: pageSetting.total,
//     data: pageSetting.resources,
//     resource: pageSetting.resource,
//     edit: pageSetting.edit,
//     query: pageSetting.query,
//     loading: commonData.loading,
//     filters: commonData.pageSettingFilters,
//     modules: commonData.modules,
//     masterFilters: commonData.masterFilters,
//   }
// }
//
// function mapDispatchToProps(dispatch) {
//   return {
//     getResource,
//     getResourceForDownload,
//     createResource,
//     fetchResourceByPage,
//     updateResource,
//     deleteResource,
//     saveResourceQuery,
//     fetchFilter,
//     fetchMasterFilter
//   };
// }
//
// export default connect(mapStateToProps, mapDispatchToProps())(PageSettingPopUp);
